fragment Config on TemporaryUploadConfig {
    action
    postData
    filePrefix
}
